import { render, staticRenderFns } from "./sourceGroup.vue?vue&type=template&id=55713d8e&scoped=true"
import script from "./sourceGroup.vue?vue&type=script&lang=js"
export * from "./sourceGroup.vue?vue&type=script&lang=js"
import style0 from "./sourceGroup.vue?vue&type=style&index=0&id=55713d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55713d8e",
  null
  
)

export default component.exports